@use "../../styles/effects";
@use "../../styles/colors";

.verticalSeparator {
    position: absolute;
    top: 50%;
    z-index: 10;
    height: 10px;
    width: 100%;
    cursor: row-resize;
    opacity: 0;
    transition: 0.25s;

    &.disabled {
        cursor: auto;
    }

    &.highlightSeparator {
        background: linear-gradient(to bottom, transparent 30%, colors.$blue 30%, colors.$blue 70%, transparent 70%);
        opacity: 1;
    }
}

.panel {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    @include effects.scrollbar;
}

.scrollControlled {
    overflow-y: hidden;
}

.horizontalSeparator {
    position: absolute;
    width: 10px;
    height: 100%;
    left: 50%;
    z-index: 1;
    cursor: col-resize;
    opacity: 0;
    transition: 0.25s;

    &.disabled {
        cursor: auto;
    }

    &.highlightSeparator {
        background: linear-gradient(to right, transparent 30%, colors.$blue 30%, colors.$blue 70%, transparent 70%);
        opacity: 1;
    }
}

.top {
    top: 0;
    left: 0;
    right: 0;
    bottom: 50%;
    position: absolute;
    opacity: 0;
    transition: opacity 0.75s;
}

.bottom {
    bottom: 0;
    left: 0;
    right: 0;
    top: 50%;
    position: absolute;
    opacity: 0;
    transition: opacity 0.75s;
}

.left {
    left: 0;
    top: 0;
    right: 50%;
    bottom: 0;
    position: absolute;
    opacity: 0;
    transition: opacity 0.75s;
}

.right {
    left: 50%;
    top: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    opacity: 0;
    transition: opacity 0.75s;
}

.horizontalSplitGroup {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}

.verticalSplitGroup {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
}